(function ($) {
	var isMobile = setIsMobile($(window).width());

	function setIsMobile(width) {
		return width < 768;
	}

	$(window).resize(function () {
		isMobile = setIsMobile($(window).width());
	});

	$('.footer-menu > li > a').on('click', function (event) {
		event.preventDefault();
		if (isMobile) {
			const menuItem = $(this);

			menuItem.toggleClass('open');
			menuItem.hasClass('has-not-bottom-border')
				? setTimeout(function () { menuItem.removeClass('has-not-bottom-border'); }, 200)
				: menuItem.addClass('has-not-bottom-border');
			menuItem.next('.sub-menu').slideToggle('fast');
		}
	});
}(jQuery));